import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import { EnvironmentNames } from 'constants/App'

const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN
  const environment = process.env.REACT_APP_ENV || EnvironmentNames.LOCAL

  // DSNがない場合、またはlocal環境の場合は初期化しない
  if (!dsn || environment === EnvironmentNames.LOCAL) {
    return
  }

  // 環境変数からサンプリングレートを取得（未定義の場合は0）
  const sampleRate = parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || '0')
  const tracesSampleRate = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0')

  Sentry.init({
    dsn,
    environment,
    sampleRate,
    tracesSampleRate,
    integrations: [
      new BrowserTracing({
        // INP（Interaction to Next Paint）を記録してインタラクション応答速度を測定
        enableInp: true,
      }),
    ],

    beforeSend(event, hint) {
      // iOS Safari/WKWebViewの既知のバグによるエラーをフィルタリング
      // https://github.com/getsentry/sentry-javascript/issues/2342
      if (hint.originalException) {
        const exception = hint.originalException
        const errorMessage = exception.message || String(exception)
        if (
          errorMessage.includes('NotFoundError') &&
          errorMessage.includes('The object can not be found here')
        ) {
          return null // Sentryに送信しない
        }

        // APIエラーの場合、data.errors配列を展開
        if (exception.data && exception.data.errors && Array.isArray(exception.data.errors)) {
          event.extra = {
            ...event.extra,
            'api_errors_detail': exception.data.errors,
          }
        }

        // レスポンスデータ全体も保存
        if (exception.response && exception.response.data) {
          event.extra = {
            ...event.extra,
            'response_data_raw': JSON.stringify(exception.response.data, null, 2),
          }
        }

        // エラーメッセージの詳細化
        if (exception.message) {
          event.extra = {
            ...event.extra,
            'error_message_detail': exception.message,
          }
        }
      }

      return event
    },
  })
}

export default initSentry
